// src/store/slices/loaderSlice.js
import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
  name: "loader",
  initialState: {
    loading: false,
    isCrmIntitialized: false,
  },
  reducers: {
    showLoader: (state) => {
      state.loading = true;
    },
    hideLoader: (state) => {
      state.loading = false;
    },
    toggleCRMinit: (state) => {
      state.isCrmIntitialized = !state.isCrmIntitialized;
    },
  },
});

export const { showLoader, hideLoader, toggleCRMinit } = loaderSlice.actions;

export default loaderSlice.reducer;
